import React from "react";
import { connect } from "react-redux";
import { Row, Col, Spin } from "antd";
import "./InvestorDetails.scss";
import { getFileNameFromUrl } from "../../../../Utils/helper";
const InvestorDetails = (props) => {
  const {
    investor_name,
    startup_name,
    date,
    status,
    amount,
    funding_type,
    accredition_method,
    signatory_details,
    closing_agreements,
    firm_details,
  } = props?.location?.state;
  return (
    <div className="transaction-investor-details-container">
      <div className="top-transaction">
        <h6>Transactions</h6>
      </div>
      <div className="investor-details-wrap">
        {props?.loading ? (
          <Spin />
        ) : (
          <>
            <Row gutter={30}>
              <Col span={20}>
                <div className="brief-detail">
                  <Row gutter={24}>
                    <Col span={8}>
                      <div className="box-wrap">
                        <span className="label">Investor Name</span>
                        {investor_name ? (
                          <span className="dark-value">{investor_name}</span>
                        ) : (
                          <span className="value">N/A</span>
                        )}
                      </div>
                      <div className="box-wrap">
                        <span className="label">Startup Name</span>
                        {startup_name ? (
                          <span className="dark-value">{startup_name}</span>
                        ) : (
                          <span className="value">N/A</span>
                        )}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className="box-wrap">
                        <span className="label">Date</span>
                        <span className="value">{date}</span>
                      </div>
                      <div className="box-wrap">
                        <span className="label">Amount</span>
                        <span className="value">{amount}</span>
                      </div>
                      <div className="box-wrap">
                        <span className="label">Accreditation Method</span>
                        <span className="value">
                          {accredition_method || "N/A"}
                        </span>
                      </div>
                      <div className="box-wrap">
                        <span className="label">
                          Signatory Details if required
                        </span>
                        <span className="value">
                          {!signatory_details ||
                          Object.keys(signatory_details || {})?.length == 0
                            ? "No"
                            : "Yes"}
                        </span>
                      </div>
                      <div className="box-wrap">
                        <span className="label closing-doc-label">
                          Closing Documents
                        </span>
                        <span className="closing-agreements-wrap">
                          {closing_agreements &&
                          closing_agreements?.length !== 0
                            ? closing_agreements?.map((i, index) => {
                                return (
                                  <div className="closing-agreements-link">
                                    <a
                                      href={i}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="filename"
                                      key={index}
                                    >
                                      {getFileNameFromUrl(i)}
                                    </a>
                                  </div>
                                );
                              })
                            : "N/A"}
                        </span>
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className="box-wrap">
                        <span className="label">Status</span>
                        <div className="pill">
                          <span className="value">{status}</span>
                        </div>
                      </div>
                      <div className="box-wrap">
                        <span className="label">Funding Method</span>
                        <span className="value">{funding_type || "ACH"}</span>
                      </div>
                      <div className="box-wrap">
                        <span className="label">
                          Firm or Fund Details if required
                        </span>
                        <span className="value">
                          {!firm_details ||
                          Object.keys(firm_details || {})?.length == 0
                            ? "No"
                            : "Yes"}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default connect(null, null)(InvestorDetails);
